var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.3 8.22998H15.82C14.84 8.22998 13.97 8.76998 13.53 9.64998L12.69 11.31C12.49 11.71 12.09 11.96 11.65 11.96H8.37C8.06 11.96 7.62 11.89 7.33 11.31L6.49 9.65998C6.05 8.78998 5.17 8.23998 4.2 8.23998H0.7C0.31 8.23998 0 8.54998 0 8.93998V12.2C0 15.83 2.18 18 5.82 18H14.2C17.63 18 19.74 16.12 20 12.78V8.92998C20 8.54998 19.69 8.22998 19.3 8.22998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 5.81V6.85C19.78 6.77 19.54 6.73 19.3 6.73H15.82C14.27 6.73 12.88 7.59 12.19 8.97L11.44 10.45H8.58L7.83 8.98C7.14 7.59 5.75 6.73 4.2 6.73H0.7C0.46 6.73 0.22 6.77 0 6.85V5.81C0 2.17 2.17 0 5.81 0H9.25V3.19L8.53 2.47C8.24 2.18 7.76 2.18 7.47 2.47C7.18 2.76 7.18 3.24 7.47 3.53L9.47 5.53C9.48 5.54 9.49 5.54 9.49 5.55C9.56 5.61 9.63 5.66 9.71 5.69C9.81 5.73 9.9 5.75 10 5.75C10.1 5.75 10.19 5.73 10.28 5.69C10.37 5.66 10.46 5.6 10.53 5.53L12.53 3.53C12.82 3.24 12.82 2.76 12.53 2.47C12.24 2.18 11.76 2.18 11.47 2.47L10.75 3.19V0H14.19C17.83 0 20 2.17 20 5.81Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.7d3f74fa2f3d95dda7fe43cb0286a327.svg";
export { ForwardRef as ReactComponent };